import { render, staticRenderFns } from "./[id].vue?vue&type=template&id=dc9b8a24&scoped=true&"
import script from "./[id].vue?vue&type=script&lang=js&"
export * from "./[id].vue?vue&type=script&lang=js&"
import style0 from "./[id].vue?vue&type=style&index=0&id=dc9b8a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9b8a24",
  null
  
)

export default component.exports